import 'masonry-layout/masonry';

function initExhibitionSpacesInAccordions() {
  let accordions = document.querySelectorAll('.accordion');
  if (accordions) {
    accordions.forEach((item) => {
      let spaces = item.querySelectorAll('.c-exhibition-space:not(.c-exhibition-space--rerendered)');
      if (spaces) {
        let Masonry = require('masonry-layout');
        spaces.forEach((space) => {
          space.classList.add('c-exhibition-space--transparent');
        });

        item.addEventListener('shown.bs.collapse', () => {
          let spaces = item.querySelectorAll('.c-exhibition-space:not(.c-exhibition-space--rerendered)');
          spaces.forEach((masonryItem) => {
            let masonryInstance = Masonry.data(masonryItem);
            // double time here because first time is not enough
            masonryInstance.layout();
            masonryInstance.layout();
            masonryItem.classList.add('c-exhibition-space--rerendered');
          });
        });
      }
    });
  }
}

initExhibitionSpacesInAccordions();
